import * as actions from '../actions/actions'


const card = (state = {}, action) => {
  switch (action.type) {
    case actions.POPULATE_CARDS:
      return Object.assign({},state,{cards:action.cards});
    case actions.SELECT_CARD:
      return Object.assign({},state,{requestedLast4Digits:action.last4Digits});    
    case actions.SET_PIN:
      return Object.assign({},state,{pin:action.pin});
    case actions.SET_TIMER:
      return Object.assign({},state,{time:action.time, percent:action.percent});    
    default:
      return state;
  }
}


export default card


// WEBPACK FOOTER //
// ./src/reducers/card.js